import { AppRoutes } from "../../Core/App/AppRoutes";
import { getArtWorkRoutes } from "./Routes/ArtWorksRoutes";
import { getSectionRoutes } from "./Routes/SectionRoutes";
import { getInformationsRoutes } from "./Routes/InformationsRoutes";

export const DEFAULT_ROOT = AppRoutes.SECTION;

export const getAppRoutes = () => [...getArtWorkRoutes(), ...getSectionRoutes(), ...getInformationsRoutes()];
